"use client";

import { useParams } from "next/navigation";
import Typography from "@mui/material/Typography";
import clsx from "clsx";


export default function ListItem({ item }) {
  const { category } = useParams();
  return (
    <div
      className={clsx({
        "list-item": true,
        active: item.name.endsWith(category),
      })}
      style={{
        display: "flex",
        alignItems: "center", // Centra verticalmente texto y foto
        gap: "8px", // Espacio entre imagen y texto
      }}
    >
      <img src={item.photo} width={30} alt={item.name} />
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
        }}
      >
        {item.name}
      </Typography>
    </div>
  );
}
